/* eslint-disable  react/jsx-props-no-spreading */
import React, { useRef } from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import { useRefSize } from 'components/shared/hooks';

type LoadingButtonProps = ButtonProps & {
  pending: boolean;
};

const LoadingButton: React.FC<LoadingButtonProps> = ({
  pending,
  children,
  disabled,
  ...props
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const buttonLabelSize = useRefSize(buttonRef, 'firstElementChild');
  return (
    <Button {...props} ref={buttonRef} disabled={pending || disabled}>
      {pending ? (
        <CircularProgress
          size={buttonLabelSize}
          title="loading spinner"
          aria-hidden
        />
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadingButton;
